import type { DoctorSlotsByDate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/types'

/**
 * Есть ли хотя бы один свободный слот.
 *
 * Заглушка «Запись недоступна» показывается, если слоты ожидались
 * (`has_slots` у клиники / телемед), но свободных нет.
 */
export default function hasFreeSlots(slots: DoctorSlotsByDate): boolean {
  return Object.values(slots).some(daySlots => daySlots.length > 0)
}
